import { Flex, Loader } from '@mantine/core';

export const LoadingStateComponent = () => {
  return (
    <Flex h="30vw" w="100%" justify="center" align="center">
      <Loader />
    </Flex>
  );
};
